module.exports = __webpack_public_path__ + "22a2c54dad3a53afa69152c29608a924.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/floatie-alligator-s.png
// module id = 1887
// module chunks = 0